export enum CoreUrlParams {
	searchQuery = 'QUERY',
	searchSecondaryQuery = 'SECONDARY_QUERY',
	mainSearchQuery = 'MAIN_SEARCH_QUERY'
}
